import { Controller } from '@hotwired/stimulus';
import Axios from "../axios";
import SliderController from "./slider-controller";
export default class extends Controller {
    connect() {
        this.filters = {};
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.filter();
    }

    filter() {
        const self = this;
        const type = self.element.dataset.type;
        this.element.parentElement.querySelectorAll('select').forEach((select) => {

            self.filters[select.name] = select.value;

            select.addEventListener('change', () => {
                self.filters[select.name] = select.value;
                self.empty();
                self.fetchPosts(type, 0, 20, self.filters).then(response => {
                    if (response && response.data) {
                        self.insert(response.data);
                        SliderController.refreshSliders();
                    }
                }).catch(reason => {
                    // eslint-disable-next-line no-console
                    console.log(reason);
                });
            });
        });
    }

    async fetchPosts(type, from, limit, filters) {
        const data = {
            rest_language: this.currentLanguageCode,
            type: type,
            from: from,
            limit: limit,
            filters: JSON.stringify(filters),
        };

        const params = Object.keys(data).map(function (k) {
            return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
        }).join('&');

        const url = `/wp-json/api/fetch-posts/?${params}`;

        let response = null;
        try {
            response = await Axios.get(url);
            response = response.data.data;
        } catch (error) {
            response = error.response.data.data;
        }

        return response;
    }

    empty() {
        const list = this.element.querySelector('.splide__list');
        list.classList.add('loading');
        list.innerHTML = '';
    }

    insert(html) {
        const list = this.element.querySelector('.splide__list');
        list.classList.remove('loading');
        list.insertAdjacentHTML('beforeend', html);
    }
}
